import { Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'

const SupplyBillAgreeIco = ({ ico, text, textOk, value, onClick, classNameMain }) => {

    const [classNameTemp, setClassNameTemp] = useState('supplyAgrees')

    useEffect(() => {
        if (classNameMain) {
            setClassNameTemp(classNameMain)
        }
    }, [classNameMain])

  return (
    <p 
        className={
            value === true ? `${classNameTemp}__agree` :
            value === false ? `${classNameTemp}__disagree` : 'approval'
        }
        onClick={onClick}
    >
        <Tooltip title={
            text + ': ' + 
            (
                value === true ? 
                    textOk ? textOk : 'Погоджено' : 
                value === false ? 'Не погоджено' : 'Очікує'
            )
        }>
            {ico}
        </Tooltip>
    </p>
  )
}

export default SupplyBillAgreeIco